import React, { useState, useEffect, useCallback } from 'react';
import Toast from './toast';
import './toastContainer.css';

const ToastContainer = () => {
  const [toast, setToast] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);

  const addToast = useCallback((message, type) => {
    const newToast = { id: Math.random().toString(36).substring(7), message, type };
    setToast(newToast);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      setToast(null);
    }, 3000);

    setTimeoutId(newTimeoutId);
  }, [timeoutId]);

  useEffect(() => {
    window.showToast = addToast;
  }, [addToast]);

  return (
    <div className="toast-container">
      {toast && <Toast key={toast.id} id={toast.id} message={toast.message} type={toast.type} />}
    </div>
  );
};

export default ToastContainer;
